// src/services/api.js
const BASE_URL = "https://iap.muyaz.com/erp/api/";

// --- LOADING TRACKER LOGIC ---
let activeRequests = 0;
let onStatusChange = null;

export const setApiStatusListener = (callback) => {
  onStatusChange = callback;
};

const updateStatus = (isLoading) => {
  if (onStatusChange) onStatusChange(isLoading);
};
// -----------------------------

const apiRequest = async (endpoint, options = {}) => {
  // Start Loading
  activeRequests++;
  updateStatus(true);

  const token = localStorage.getItem("token");
  const isFormData = options.body instanceof FormData;

  const headers = {
    ...(!isFormData && { "Content-Type": "application/json" }),
    ...options.headers,
  };

  const publicRoutes = [
    "auth/login",
    "users/forgotPassword",
    "users/resetPassword",
    "tenants/googleonboarding",
    "subscriptions/leads",
    "subscriptions/packages",
  ];

  const isPublic = publicRoutes.some((path) => endpoint.includes(path));

  if (token && !isPublic) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const config = {
    ...options,
    method: options.method || "GET",
    headers,
  };

  if (options.body && typeof options.body === "object" && !isFormData) {
    config.body = JSON.stringify(options.body);
  }

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, config);

    let result;
    try {
      result = await response.json();
    } catch {
      result = null;
    }

    if (!response.ok) {
      const message =
        result?.message || result?.error || `Error ${response.status}`;
      throw new Error(message);
    }

    return result;
  } catch (error) {
    // Custom message for network / CORS / offline errors
    if (error.message === "Failed to fetch" || error.name === "TypeError") {
      throw new Error("Unable to connect to the server. Try again.");
    }

    // Re-throw other errors (4xx, 5xx, etc.)
    throw error;
  } finally {
    activeRequests = Math.max(0, activeRequests - 1);
    if (activeRequests === 0) {
      setTimeout(() => {
        if (activeRequests === 0) updateStatus(false);
      }, 300);
    }
  }
};

export default apiRequest;
